import type { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import * as userApi from '@/services/userService';

interface EmailOnboardingPayload {
  user: {
    email: string;
  };
}

interface NylasCallbackPayload {
  code: string;
}

export function* emailOnboardingRequest({ payload }: { payload: EmailOnboardingPayload }): SagaIterator {
  try {
    console.log('emailOnboardingRequest saga started');
    const response: { data: { authUrl: string } } = yield call(userApi.getNylasAuthUrl, {
      email: payload.user.email,
      scopes: ['email.read_only', 'email.send'],
    });
    console.log('Nylas auth response:', response)

    if (response && response.data && response.data.authUrl) {
      console.log('Attempting to open URL:', response.data.authUrl)
      const newWindow = window.open(response.data.authUrl, '_blank', 'noopener,noreferrer')
      if (newWindow) {
        newWindow.focus()
      } else {
        console.error('Failed to open new window. Popup might be blocked.')
        alert('Please allow popups for this site to continue with Nylas authentication.')
      }
    } else {
      throw new Error('No auth URL returned from the server')
    }
  } catch (error) {
    console.error('Email onboarding error:', error)
    yield put({ type: 'EMAIL_ONBOARDING_FAILURE', error })
  }
}

export function* emailCalendarOnboardingRequest({ payload }: { payload: EmailOnboardingPayload }): SagaIterator {
  try {
    console.log('emailCalendarOnboardingRequest saga started')
    const response: { data: { authUrl: string } } = yield call(userApi.getNylasAuthUrl, {
      email: payload.user.email,
      scopes: ['email.read_only', 'email.send', 'calendar'],
    })
    console.log('Nylas auth response:', response)

    if (response && response.data && response.data.authUrl) {
      console.log('Attempting to open URL:', response.data.authUrl);
      const newWindow = window.open(response.data.authUrl, '_blank', 'noopener,noreferrer')
      if (newWindow) {
        newWindow.focus()
      } else {
        console.error('Failed to open new window. Popup might be blocked.')
        alert('Please allow popups for this site to continue with Nylas authentication.')
      }
    } else {
      // If no authUrl is returned, it might mean the user is already authenticated
      yield put({ type: 'NYLAS_AUTH_SUCCESS' })
    }
  } catch (error) {
    console.error('Email and calendar onboarding error:', error)
    yield put({ type: 'EMAIL_CALENDAR_ONBOARDING_FAILURE', error })
  }
}

export function* handleNylasCallback({ payload }: { payload: NylasCallbackPayload }): SagaIterator {
	try {
	  const { code } = payload
	  yield call(userApi.exchangeNylasCode, { code })
	  yield put({ type: 'NYLAS_AUTH_SUCCESS' })
	} catch (error) {
	  console.error('Nylas callback error:', error)
	  yield put({ type: 'NYLAS_AUTH_FAILURE', error })
	}
  }
